import { reactive } from '@vue/composition-api';
import { PhotoModalWithEditState } from '@/models/photoModal';
import { dtFormat } from '@/lib/dateHelper';
import { HokkaidoAirportReportPhotoExt } from '@/models/externalReports/hokkaidoAirport/hokkaidoAirportReport';
export interface UsePhotoModalResult {
  photoModalState: PhotoModalWithEditState;
  showPhotoModal: (photoType: string, photos: HokkaidoAirportReportPhotoExt[]) => void;
  refreshPhotos: (photos: HokkaidoAirportReportPhotoExt[]) => void;
  hidePhotoModal: () => void;
}
export function usePhotoModal(): UsePhotoModalResult {
  const photoModalState = reactive<PhotoModalWithEditState>({
    shouldShowPhotoModal: false,
    title: '',
    photos: [],
  });

  const refreshPhotos = (photos: HokkaidoAirportReportPhotoExt[]): void => {
    const newPhotos = photos.map((photo) => ({
      id: photo.id,
      photoTitle: photo.dispOrder + '. ' + dtFormat(photo.ts),
      savedImage: photo.savedImage,
      comment: photo.comment ?? '',
      type: photo.photoType,
      order: photo.dispOrder,
      lon: photo.lon,
      lat: photo.lat,
    }));
    newPhotos.sort((a, b) => a.order - b.order);
    photoModalState.photos = [...newPhotos];
  };

  const showPhotoModal = (photoType: string, photos: HokkaidoAirportReportPhotoExt[]): void => {
    photoModalState.title = photoType + '写真';
    refreshPhotos(photos);
    photoModalState.shouldShowPhotoModal = true;
  };
  const hidePhotoModal = () => {
    photoModalState.shouldShowPhotoModal = false;
    photoModalState.title = '';
    photoModalState.photos = [];
  };

  return {
    photoModalState,
    showPhotoModal,
    refreshPhotos,
    hidePhotoModal,
  };
}
